'use client'

import { useProfileActivation } from '@/auth/useProfileActivation'
import { ProfileOnboardingDialog } from '@/components/views/accountManagement/profileOnboarding/ProfileOnboardingDialog'
import { useLocation } from '@/routing'

/** Routes that own their own auth/registration UI and must never be overlaid. */
const EXCLUDED_PREFIXES = [
  '/register',
  '/login',
  '/logout',
  '/auth',
  '/forgot-password',
]

/**
 * Global gate (mounted once in the authenticated app shell): forces the
 * non-closeable profile-onboarding dialog for a freshly registered user who has
 * no activated profile yet and has not skipped. Because such a user has zero
 * memberships, it never collides with the context-switch dialog (which targets
 * users who already belong to another context).
 */
export const ProfileOnboardingGate = () => {
  const { shouldShowOnboarding } = useProfileActivation()
  const location = useLocation()

  const onExcludedRoute = EXCLUDED_PREFIXES.some((prefix) =>
    location.pathname.startsWith(prefix)
  )

  if (onExcludedRoute || !shouldShowOnboarding) {
    return null
  }

  return <ProfileOnboardingDialog closable={false} />
}
